import * as React from 'react';
import {Reporter} from '../core/reporter';

export type AnalyticsContext<T extends string> = {
  analyticsReporter: Reporter<T>;
};

export const createAnalyticsContext = <T extends string>(
  analyticsReporter: Reporter<T>,
) => {
  return React.createContext<AnalyticsContext<T>>({analyticsReporter});
};
